// src/components/menus/MobileDrawer.jsx
import { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

export default function MobileDrawer() {
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser) return;
    const unsub = onSnapshot(
      doc(db, "profilsUsers", currentUser.uid),
      (snap) => {
        if (snap.exists()) setRole(snap.data().role);
      }
    );
    return () => unsub();
  }, [currentUser]);

  const items = [
    { label: "Agents", path: "/app/agents" },
    { label: "Dashboard", path: "/app/dashboard" },
    { label: "Help/FAQ", path: "/app/help" },
  ];

  if (role === "SuperAdmin") {
    items.push({ label: "Super Admin", path: "/app/superadmin/users" });
  }

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 260 }} role="presentation">
          <List>
            {items.map((i) => {
              const selected = location.pathname === i.path;
              return (
                <ListItemButton
                  key={i.path}
                  selected={selected}
                  onClick={() => {
                    navigate(i.path);
                    setOpen(false);
                  }}
                >
                  <ListItemText
                    primary={i.label}
                    primaryTypographyProps={{
                      fontWeight: selected ? 700 : 500,
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </>
  );
}
